import React, { useEffect, useState } from 'react';
import '../MouseAwayPop/MouseAwayPopup.css';
import axios from 'axios';
import { basePath } from '../../index';
//import MobileIcon from "../SmcLife/Images/mobile.svg";
import MaskedInput from 'react-text-mask';
import Celebrating from './CelebratingParticles';
/*import OtherLink from '../OtherLink';*/
/*import DontLeaveImage from "../Images/dont-leave-term-insurance.png"*/
import Popup_Image from "../Images/Popup_Image.png";
import { mobilePattern } from '../UtilityComponents/UtilityFunction';
import GoogleRating from '../UtilityComponents/GoogleRating';
import PublicDataStats from '../UtilityComponents/PublicDataStats';

const MouseAwayPopup = ({ onClose, IsMobileNumber }) => {
    const [isSuccessPopup, setIsSuccessPopup] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const [mobileNumber, setMobileNumber] = useState("");
    const [gpsLocation, setGpsLocation] = useState(null);
    const [errors, setErrors] = useState({});
    const [isMobileMasked, setIsMobileMasked] = useState(false);


    useEffect(() => {
        const getUserLocation = async () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setGpsLocation({
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        });
                    },
                    (error) => console.log(error)
                );
            }
        };

        getUserLocation();
    }, []);


    useEffect(() => {
        if (IsMobileNumber) {
            setMobileNumber(IsMobileNumber);
        }
    }, [IsMobileNumber])

    const getBrowserName = () => {
        const userAgent = navigator.userAgent;
        if (userAgent.indexOf('Chrome') > -1) return 'Chrome';
        if (userAgent.indexOf('Safari') > -1) return 'Safari';
        if (userAgent.indexOf('Firefox') > -1) return 'Firefox';
        if (userAgent.indexOf('MSIE') > -1 || userAgent.indexOf('Trident/') > -1) return 'Internet Explorer';
        if (userAgent.indexOf('Edge') > -1) return 'Edge';
        if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) return 'Opera';
        if (userAgent.indexOf('Edg') > -1) return 'Microsoft Edge (Chromium)';
        return 'Unknown';
    };
    const startTime = Date.now();


    const submitForm = () => {
        let error = {};
        let goto = true;

        if (mobileNumber === "") {
            goto = false;
            error["mobileNumber"] = "Please enter mobile number";
        }
        else if (mobileNumber.length !== 10) {
            goto = false;
            error["mobileNumber"] = "Please enter valid mobile number";
        }
        else if (mobileNumber === "9999999999" || mobileNumber === "8888888888" || mobileNumber === "7777777777" || mobileNumber === "6666666666") {
            goto = false;
            error["mobileNumber"] = "Please enter valid mobile number"
        }
        else if (mobilePattern.test(mobileNumber)) {
            goto = false;
            error["mobileNumber"] = "First 6 digits cannot be all the same"
        }
        setErrors(error);
        if (goto) {
            HandleGetQuote();
        }
    }

    const maskMobileNumber = (mobile) => {
        if (!mobile) return "";

        const value = mobile.toString();

        if (value.length !== 10) {
            return value;
        }

        return `${value.substring(0, 2)}******${value.substring(8)}`;
    };

    const HandleGetQuote = async () => {
        const endTime = Date.now();

        const timeSpent = endTime - startTime;

        if (!mobileNumber) {
            console.error("Mobile number is required");
            return;
        }

        const locationString = gpsLocation
            ? `Lat:${gpsLocation.latitude} | Long:${gpsLocation.longitude}`
            : "Lat:0 | Long:0";

        const requestData = {
            "MobileNo": mobileNumber,
            "Url": window.location.href.split("?")[0],
            "IpAddress": "",
            "Location": locationString,
            "BrowserInfo": getBrowserName(),
            "PageRetention": 0,
            "EmailId": "",
            "ProductType": "INV"
        };

        try {
            const Model = {
                URL: "PromotionSaveTax",
                Req: JSON.stringify(requestData),
            };
            axios.post('central/centralcall/callreqwithheader', Model).then(res => {
                if (res.data.StatusCode === 200) {
                    setIsSuccessPopup(true);
                }
                console.log({ res });
            })
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    return (
        <div className="modalBackdrop_Share">
            {isSuccessPopup ? (
                <div className="modal_MouseAway">
                    <div className="modalHeader model_padding" onClick={onClose}>
                       {/* <h3 className="share_heading">Secure Your Family Today!</h3>*/}
                        <button className="closeButton2" ><i class="fas fa-times"></i></button>
                    </div>
                    <div className="">
                        <div className="Code_shared_success">
                            <h4>Your request has been <br />submitted <span>successfully!</span></h4>
                            <p>Team will contact you soon to assist for <br /> your Investment plan.</p>
                            <small>Business Hours: Mon–Sat, 10:00 AM – 6:00 PM</small>
                        </div>
                    </div>
                    <div className="model_PrmLinks">
                        {/*<OtherLink />*/}
                        {/* <GoogleRating/>*/}
                        <div class="otherLinksSmc">
                            <div class="StepsRow">
                                <div class="StepsColm">
                                    <img src={require("../Images/business-premium.svg").default} />
                                    <div>
                                        <small>
                                            Business Premium
                                            <br />
                                            <b>31.93 Billion +</b>
                                        </small>
                                    </div>
                                </div>
                                <div class="StepsColm">
                                    <img src={require("../Images/policies-sold.svg").default} />
                                    <div>
                                        <small>
                                            Policies sold
                                            <br />
                                            <b>12.01 Million +</b>
                                        </small>
                                    </div>
                                </div>
                                <div class="StepsColm">
                                    <img src={require("../Images/claims-assisted.svg").default} />
                                    <div>
                                        <small>
                                            Claims assisted
                                            <br />
                                            <b>2.37 Million +</b>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Celebrating />
                </div>
            ) : (
                <div className="modal_MouseAway">
                    <button className="closeButton2" onClick={onClose}><i class="fas fa-times"></i></button>
                    <div className="row">
                        <div className="col-md-4">
                            <div className="InfoImage">
                                {/*{DontLeaveImage}*/}
                                <img src={Popup_Image} alt="" />
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="GetQuoteSec">
                                <div className="GroupOfCnt">
                                    <h5>Secure Your Family Today!</h5>
                                    <p>Don’t wait - secure your Future and prepare for a worry-free tomorrow!</p>
                                </div>
                                <div className="inputGroup">
                                    <div className="share_inp LandingLife">
                                        <h4 class="mobileView">Get Free Investment Quote</h4>
                                        <span className="countryCodeStyleLnd">
                                            {isActive || mobileNumber ? '+91' : ''}
                                        </span>
                                        {/*<MaskedInput
                                            className="inputText inputForMobile"
                                            mask={[
                                                /[6-9]/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                                /\d/,
                                            ]}
                                            guide={false}
                                            showMask={false}
                                            placeholder=""
                                            name="mobileNumber"
                                            value={mobileNumber}
                                            onChange={(e) => setMobileNumber(e.target.value)}
                                            onBlur={() => setIsActive(false)}
                                            onFocus={() => setIsActive(true)}
                                            required
                                        />*/}

                                            {isMobileMasked ? (
                                                <input
                                                    type="text"
                                                    className="inputText inputForMobile"
                                                    value={maskMobileNumber(mobileNumber)}
                                                    onFocus={() => {
                                                        setIsMobileMasked(false);
                                                        setIsActive(true);
                                                    }}
                                                    readOnly
                                                />
                                            ) : (
                                                <MaskedInput
                                                    className="inputText inputForMobile"
                                                    mask={[
                                                        /[6-9]/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                        /\d/,
                                                    ]}
                                                    guide={false}
                                                    showMask={false}
                                                    placeholder=""
                                                    name="mobileNumber"
                                                    value={mobileNumber}
                                                    onChange={(e) => {
                                                        setMobileNumber(e.target.value);
                                                        setIsMobileMasked(false);
                                                    }}
                                                    onFocus={() => {
                                                        setIsActive(true);
                                                        setIsMobileMasked(false);
                                                    }}
                                                    onBlur={() => {
                                                        setIsActive(false);

                                                        if (mobileNumber.length === 10) {
                                                            setIsMobileMasked(true);
                                                        }
                                                    }}
                                                    required
                                                />
                                            )}

                                        <label className="label">Enter Mobile Number</label>
                                    </div>

                                    <button className="shareButton12" onClick={submitForm} disabled={!mobileNumber}>Get Quotes</button>
                                        <a className="TandC" href="https://www.smcinsurance.com/terms-of-use">*T&C Apply</a>
                                </div>
                                <span className="ErrorText">{errors["mobileNumber"]}</span>
                            </div>
                        </div>
                    </div>
                    <div className="model_PrmLinks">

                            <PublicDataStats />
                            {/*<OtherLink />*/}
                            {/*<GoogleRating/>*/}
                            {/*<div class="otherLinksSmc">
                                <div class="StepsRow">
                                    <div class="StepsColm">
                                        <img src={require("../Images/business-premium.svg").default} />
                                        <div>
                                            <small>
                                                Business Premium
                                                <br />
                                                <b>31.93 Billion +</b>
                                            </small>
                                        </div>
                                    </div>
                                    <div class="StepsColm">
                                        <img src={require("../Images/policies-sold.svg").default} />
                                        <div>
                                            <small>
                                                Policies sold
                                                <br />
                                                <b>12.01 Million +</b>
                                            </small>
                                        </div>
                                    </div>
                                    <div class="StepsColm">
                                        <img src={require("../Images/claims-assisted.svg").default} />
                                        <div>
                                            <small>
                                                Claims assisted
                                                <br />
                                                <b>2.37 Million +</b>
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>*/}
                    </div>
                </div>
            )
            }
        </div >
    );
};

export default MouseAwayPopup;
